'use client';
import { useEffect, useRef, useState, type PropsWithChildren } from 'react';
import { clsx } from 'clsx';
import { Icon } from 'components/UI/Icon';
import type { PropsWithClassName } from 'types/react-props';
import styles from './Collapsible.module.scss';

export type CollapsibleProps = PropsWithClassName<
  PropsWithChildren<{
    readonly showMoreText: string;
    readonly showLessText: string;
  }>
>;

const Collapsible = ({ showMoreText, showLessText, children, className }: CollapsibleProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isShown, setIsShown] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [isShown]);

  return (
    <div className={className}>
      <div
        ref={contentRef}
        className={styles.contentWrapper}
        aria-hidden={!isShown}
        style={{ height: isShown ? contentHeight : 0 }}
      >
        <div className={styles.content}>{children}</div>
      </div>
      <button className={styles.button} onClick={() => setIsShown(!isShown)}>
        <Icon name="chevronAltDown" className={clsx({ [styles.rotate]: isShown })} size={12} />
        <span className={styles.buttonText}>{isShown ? showLessText : showMoreText}</span>
      </button>
    </div>
  );
};

export default Collapsible;
